module.exports = __webpack_public_path__ + "static/img/lp-1.688eb28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/lp-1.png
// module id = IK/8
// module chunks = 0